{
  "dashboard": {
    "title": "Mein Arbeitsumfeld",
    "subtitle": "Dein persönlicher Beitrag im Unternehmen – Prozesse, Aufwand, Systeme und Netzwerk.",

    "stats": {
      "activeProcesses": "Aktive Prozesse",
      "activeProcessesDesc_one": "Beteiligung",
      "activeProcessesDesc_other": "Beteiligungen",
      "totalActivities_one": "Aktivität in den Prozessen",
      "totalActivities_other": "Aktivitäten in den Prozessen",
      "usedSystems": "Genutzte Systeme",
      "usedSystemsDesc_one": "System",
      "usedSystemsDesc_other": "Systeme",
      "networkInteractions": "Netzwerk",
      "networkDesc_one": "Person",
      "networkDesc_other": "Personen",
      "direct": "Direkt",
      "indirect": "Indirekt"
    },
    "capacity": {
      "title": "Kapazitätsverteilung",
      "subtitle": "Aufwand pro Prozess (Std./Monat)"
    },
    "processes": {
      "title": "Prozesse & Aktivitäten",
      "activities_one": "{{count}} Aktivität",
      "activities_other": "{{count}} Aktivitäten",
      "noProcesses": "Noch keine Prozesse"
    },
    "activities": {
      "unnamed": "{{type}} (in Bearbeitung)"
    },
    "systems": {
      "title": "Meine Systeme",
      "processCount_one": "{{count}} Prozess",
      "processCount_other": "{{count}} Prozesse",
      "noSystems": "Noch keine Systeme"
    },
    "coWorkers": {
      "title": "Mein Netzwerk",
      "all": "Alle",
      "direct": "Direkt",
      "upstream": "Vorgelagert",
      "downstream": "Nachgelagert",
      "noCoWorkers": "Keine Co-Workers gefunden",
      "noCoWorkersDirect": "Keine direkten Co-Workers gefunden",
      "noCoWorkersUpstream": "Keine vorgelagerten Co-Workers gefunden",
      "noCoWorkersDownstream": "Keine nachgelagerten Co-Workers gefunden"
    },
    "hoursSuffix": "{{value}}h"
  }
}
